import { FC } from "react";
import { Box, Typography } from "@material-ui/core";

import theme from "theme";

const DataDisclosureMessage: FC = () => {
  return (
    <Box textAlign="left">
      <Typography color="primary" variant="caption">
        <strong style={{ fontWeight: theme.typography.fontWeightMedium }}>
          Data Disclosure:
        </strong>{" "}
        The Catalog Valuation App only uses this information for read-only
        access to your royalty account for the purpose of downloading statements
        and creating your valuation estimate. We do not use it to make changes
        to your account.
      </Typography>
    </Box>
  );
};

export default DataDisclosureMessage;
